import { io } from "socket.io-client";

// koneksi ke server node kamu
const socket = io("http://localhost:3000", {
  autoConnect: false, // biar bisa kontrol connect
});

export default socket;